(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["resource-library"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.resource-library').forEach(function (root) {
    var search = root.querySelector('.resource-library__search');
    var filters = root.querySelectorAll('.resource-library__filter');
    var cards = root.querySelectorAll('.resource-card');
    var noResults = root.querySelector('.resource-library__no-results');
    var activeCategory = 'all';

    function apply() {
      var q = (search.value || '').trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var matchesText = !q || card.dataset.name.indexOf(q) !== -1;
        var matchesCat = activeCategory === 'all' || card.dataset.category === activeCategory;
        var show = matchesText && matchesCat;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (noResults) noResults.hidden = visible > 0;
    }

    if (search) search.addEventListener('input', apply);
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filters.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        activeCategory = btn.dataset.category;
        apply();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
